import {useParams} from 'react-router';
import Card from '@mui/material/Card';
import {useEffect, useState} from 'react';
import allActions from '../../redux/actions/user';
import {useStyles} from './DetailsProfesseursStyle';
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import Skeleton from "@material-ui/lab/Skeleton";

export default function DetailsProfesseurs() {
  const classes = useStyles()
  const { id } = useParams()
  const [professor, setProfessor] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchProfessor = async () => {
      try {
        const response = await allActions.fetchGetAPI(`api/professeur/get-by-id/${id}`)
        setLoading(false)
        setProfessor(response.json)
      } catch (e) {
        console.error(e)
      } finally {
        setLoading(false)
      }
    }

    fetchProfessor()
  }, [id])

  return (
    <Card className={classes.card}>
      <div className={classes.grid}>
        {!loading ? <div className={classes.container}>
          <div className={classes.containerImg}>
            {professor?.image ? (
              <img src={professor?.image} alt="professor" alt={professor?.name + ' ' + professor?.surname} style={{ objectFit:'cover', width: '100%', height: 'auto' }} />
            ) : (
              <img className={classes.img} src={'/no-profil-image.png'} alt={professor?.name + ' ' + professor?.surname} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />)
            }
          </div>
          <h3>{professor?.name} {professor?.surname}</h3>
          <Divider style={{width: '100%'}} />
          <span className={classes.listActivities}>
            {professor?.activites?.map((activity, index) => (
              <Chip key={index} label={activity.name} color="primary" />
            ))}
          </span>
        </div> : <div className={classes.container}>
          <Skeleton variant="rect" width={200} height={200} />
          <Skeleton variant="text" width={200} />
          <Divider style={{width: '100%'}} />
          <span className={classes.listActivities}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} variant="text" width={100} />
            ))}
          </span>
        </div>}

        {!loading ? <div
          className={classes.description}
          dangerouslySetInnerHTML={{ __html: professor?.description }}
        /> : <Skeleton variant="text" width={500} height={500} />}
      </div>
    </Card>
  )
}
